import React, { useState } from "react";
import {
    Box,
    AccordionSummary,
    AccordionDetails,
    Grid,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Title } from "../Title/Title";
import Message from "../../../components/message";
import { MessageSections } from "../../../components/message/message";
import { AccordionWrapper } from "./styled.components";
import BarekamText from "../../../components/text";
import Container from "../Container";
import { useAppSelector } from "../../../../redux/store";
import { faqs } from "./data";

const FAQSection = () => {
    const [expanded, setExpanded] = useState<string | false>(false);
    const { languageId } = useAppSelector((state) => state.messagesReducer);

    const handleChange = (panel: string) => (_: React.SyntheticEvent, isExpanded: boolean) => {
        setExpanded(isExpanded ? panel : false);
    };
    //     {
    //         question: "In what case is the parcel cleared?",
    //         answer: `Dear BAREKAM, from March 31, 2022, the parcel will be cleared for customs in the following cases:
    //             a. when the weight of the parcel exceeds 30 kg
    //             b. the value of the parcel exceeds AMD 200,000
    //             c. the contents of the parcel are considered by the customs authorities as commercial goods, not personal.`,
    //     },
    //     {
    //         question: "How much is the customs fee?",
    //         answer: `a. For parcels weighing more than 30 kg, a customs duty is imposed in the amount of AMD 2 for each additional kilogram. 
    //         b. For parcels exceeding the specified value of AMD 200,000, the customs duty is 15% of the excess amount.
    //         c. If the above 2 cases occur for the parcel at the same time, then the basis for the customs duty is the highest of the values. 
    //         d. For commercial goods, a commercial declaration is completed.`,
    //     },
    //     {
    //         question: "How to deliver the parcel to Armenia?",
    //         answer: `Parcel delivery is carried out in 3 ways: 
    //         a)a) A BAREKAMI employee approaches and picks up the parcel from the address you specified. 
    //         b) You deliver the package to the BAREKAMI service point near your place of residence. 
    //         c) You send the parcel to the BAREKAM warehouse in your country through the postal service`,
    //     },
    //     {
    //         question: "How to receive the parcel in Armenia?",
    //         answer: `You can receive the parcels from the BAREKAM office or order the parcel delivery service. Delivery is carried out in the city of Yerevan and neighboring marzes.`,
    //     },
    //     {
    //         question: "From which countries can we send a parcel to Armenia?",
    //         answer: 'The list of countries served by BAREKAM can be found here',
    //     },
    //     {
    //         question: "How to track parcel delivery?",
    //         answer: "You can track the delivery of the parcel by entering the parcel tracking code here",
    //     },
    //     {
    //         question: "Is compensation provided in case of lost or damaged parcel?",
    //         answer: `In case of loss of the package, compensation is made in the amount of 100% of the declared value. In case of damaged parcels, compensation is provided in accordance with the company's regulations..`,
    //     },
    //     {
    //         question: "What standards must the parcel meet in order to be able to send a parcel from Armenia to Europe?",
    //         answer: `The parcel sent from Armenia to Europe should be in a strong cardboard box, the length of each side should not exceed 80 cm, the weight should not exceed 20 kilograms, and the contents should be for personal use.`,
    //     },
    //     {
    //         question: "How long does it take for the parcel to reach Armenia?",
    //         answer: "Parcel delivery from Europe to Armenia takes an average of 25 working days",
    //     },
    //     {
    //         question: "To which European countries can we send a parcel from Armenia?",
    //         answer: "You can send parcels from Armenia to France, Germany, Netherlands, Belgium and Poland",
    //     },
    // ];

    return (
        <Box sx={{ padding: "60px 0", backgroundColor: "#F8F9FA", width: "100%" }}>
            <Title>
                <Message
                    messageKey={'faq_title'}
                    sectionId={MessageSections.MAIN}
                />
            </Title>
            <Container>
                <Grid container spacing={2}>
                    {faqs[languageId - 1].map((faq, index) => (
                        <Grid item xs={12} sm={6} key={index}>
                            <AccordionWrapper
                                expanded={expanded === `panel${index}`}
                                onChange={handleChange(`panel${index}`)}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls={`panel${index}-content`}
                                    id={`panel${index}-header`}
                                >
                                    <BarekamText variant={"m"} fontWeight={600} align={"left"}>
                                        {faq.question}
                                    </BarekamText>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <BarekamText variant={"m"} fontWeight={400} align={"left"}>
                                        <div dangerouslySetInnerHTML={{ __html: faq.answer }}></div>
                                    </BarekamText>
                                </AccordionDetails>
                            </AccordionWrapper>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
};

export default FAQSection;
